import { useLocalization } from "@tm/localization"
import { Box, Button, Icon, IconButton, ModuleHeaderContainer, ModuleHeaderSlot, SearchField } from "@tm/components"
import { useCallback, useState } from "react"
import { useRepairTimesFormDefaults } from "@bundles/basket/hooks/Forms/useRepairTimesFormDefaults"
import { Navigation } from "../Navigation"
import { useOwnRepairTimesStore } from "./store"
import { DialogCustomRepairTimeAdd } from "./EditDialog"

type ModuleHeaderProps = {
    onClose?: () => void
}

export function ModuleHeader({ onClose }: ModuleHeaderProps) {
    const { translateText } = useLocalization()

    const { searchQuery, setSearchQuery, setRepairTimeToEdit } = useOwnRepairTimesStore()
    const { workCategoryItems, vatRateItems } = useRepairTimesFormDefaults()
    const [query, setQuery] = useState(searchQuery)

    function handleStartSearch() {
        setSearchQuery(query)
    }

    function handleClearSearch() {
        setSearchQuery("")
    }

    const handleNewRepairTime = useCallback(() => {
        if (vatRateItems.length && workCategoryItems.length) {
            setRepairTimeToEdit({
                type: "add",
                selectedVatRate: vatRateItems[0].vatRate,
                category: workCategoryItems[0].category,
            } as DialogCustomRepairTimeAdd)
        }
    }, [setRepairTimeToEdit, vatRateItems, workCategoryItems])

    return (
        <ModuleHeaderContainer>
            <Navigation listType="own-repair-times" />
            <ModuleHeaderSlot title={translateText(135)}>
                <SearchField
                    sx={{ width: "300px" }}
                    onStartSearch={handleStartSearch}
                    value={query}
                    onChange={setQuery}
                    onClear={handleClearSearch}
                    placeholder={`${translateText(58)} ${translateText(1098)} ${translateText(25)}`}
                />
            </ModuleHeaderSlot>
            <ModuleHeaderSlot title={translateText(177)}>
                <Button startIcon={<Icon name="plus" />} onClick={handleNewRepairTime} variant="outlined">
                    {translateText(13907)}
                </Button>
            </ModuleHeaderSlot>

            {onClose && (
                <Box ml="auto" alignSelf="start" mt={2}>
                    <IconButton variant="contained" onClick={onClose} color="primary" size="large">
                        <Icon name="close" />
                    </IconButton>
                </Box>
            )}
        </ModuleHeaderContainer>
    )
}
